module.exports = "dist/assets/images/vault.02f245379b4bff462c8f78677ead1992.svg";